<div class="om-page">
  <app-project-nav></app-project-nav>
  <app-page-header
    [title]="'objectMappings.pageTitle' | translate"
    [subtitle]="'objectMappings.pageSubtitle' | translate"
  >
    <ng-container right>
      @if (!isProjectReader()) {
        <button mat-flat-button type="button" data-testid="om-create" (click)="creating.set(true)">
          <mat-icon aria-hidden="true">add</mat-icon>
          {{ 'objectMappings.create.button' | translate }}
        </button>
      }
    </ng-container>
  </app-page-header>

  <div class="om-toolbar">
    <app-search-bar
      class="om-search"
      data-testid="om-search"
      [placeholder]="'objectMappings.searchPlaceholder' | translate"
      [value]="searchTerm()"
      (valueChange)="searchTerm.set($event)"
    />
  </div>

  @if (loading()) {
    <div class="om-loading" data-testid="om-loading">
      <mat-spinner diameter="32" />
    </div>
  } @else if (loadError()) {
    <div class="om-hint om-hint--error" role="alert" data-testid="om-error">
      <p>{{ 'objectMappings.loadError' | translate }}</p>
      <button mat-stroked-button type="button" data-testid="om-retry" (click)="load()">
        {{ 'objectMappings.retry' | translate }}
      </button>
    </div>
  } @else if (libraries().length === 0) {
    <p class="om-hint" data-testid="om-empty">{{ 'objectMappings.empty' | translate }}</p>
  } @else if (filtered().length === 0) {
    <p class="om-hint" data-testid="om-empty-filtered">{{ 'objectMappings.emptyFiltered' | translate }}</p>
  } @else {
    <div class="om-card" role="table" [attr.aria-label]="'objectMappings.tableLabel' | translate">
      <div class="om-table-header" role="row">
        <div class="om-col om-col--name" role="columnheader">{{ 'objectMappings.table.name' | translate }}</div>
        <div class="om-col om-col--engine" role="columnheader">{{ 'objectMappings.table.engine' | translate }}</div>
        <div class="om-col om-col--count" role="columnheader">
          {{ 'objectMappings.table.entryCount' | translate }}
        </div>
        <div class="om-col om-col--state" role="columnheader">{{ 'objectMappings.state.column' | translate }}</div>
      </div>
      @for (library of filtered(); track library.id) {
        <div
          class="om-row"
          role="row"
          tabindex="0"
          data-testid="om-row"
          [attr.aria-label]="library.name"
          (click)="open(library)"
          (keydown.enter)="open(library)"
        >
          <div class="om-col om-col--name" role="cell">
            <span class="om-name">{{ library.name }}</span>
            @if (library.description) {
              <span class="om-desc">{{ library.description }}</span>
            }
          </div>
          <div class="om-col om-col--engine" role="cell">{{ library.engineId }}</div>
          <div class="om-col om-col--count" role="cell">
            <span class="om-pill">{{ library.entryCount }}</span>
          </div>
          <div class="om-col om-col--state" role="cell" data-testid="om-state">
            @if (stateOf(library); as libState) {
              <app-status-pill
                size="sm"
                [kind]="libState.kind"
                [label]="libState.key | translate: { count: libState.count }"
              />
            } @else {
              <span class="om-none">—</span>
            }
          </div>
        </div>
      }
    </div>
  }
</div>

@if (creating()) {
  <app-object-mapping-create-dialog
    [projectId]="projectId"
    (created)="onCreated($event)"
    (cancelled)="creating.set(false)"
  />
}
